import { DocumentVersion } from './document-version.model';

export interface SelectedVersions {
  current: DocumentVersion;
  target: DocumentVersion;
}
